const ar = {
  eyebrow: "الأسئلة الشائعة",
  title: "أسئلة متكررة",

  items: [
    {
      q: "ما الدورات التي تقدّمونها؟",
      a: "نقدّم دورات مباشرة وتفاعلية في البرمجة وهندسة البرمجيات: الذكاء الاصطناعي وتعلّم الآلة، وتصميم الخوارزميات، وأساسيات البرمجة، وبنية البرمجيات، وتطوير الويب، وتطوير تطبيقات الجوّال، وتطوير قواعد البيانات والخوادم، من المستوى المبتدئ إلى المتقدّم.",
    },
    {
      q: "هل أحتاج إلى خبرة سابقة للانضمام؟",
      a: "لا حاجة لأي خبرة سابقة. تناسب دوراتنا جميع المستويات، من المبتدئين تمامًا إلى المبرمجين ذوي الخبرة. يمكنك البدء من الصفر، وسنرشدك خطوة بخطوة.",
    },
    {
      q: "كيف تُقدَّم الدورات؟",
      a: "تُقدَّم جميع الدورات مباشرةً عبر الإنترنت على يد مدرّبين خبراء. الجلسات تفاعلية، مع مشاريع تطبيقية وملاحظات فورية. فاتتك جلسة؟ نوفّر تسجيلات لمراجعتها لاحقًا.",
    },
    {
      q: "ما لغات البرمجة التي تدرّسونها؟",
      a: "حسب الدورة: Python، وJavaScript، وHTML وCSS، وReact، وSwift، وKotlin، وSQL. ستتعلّم الأدوات واللغات المناسبة للمجال الذي تتدرّب من أجله.",
    },
    {
      q: "كيف يمكنني التسجيل في دورة؟",
      a: "تصفّح الدورات المتاحة، واختر ما يناسب مستواك، وسجّل. ستتلقّى كل ما تحتاجه للبدء. تحتاج إلى مساعدة في الاختيار؟ فريقنا هنا لمساعدتك.",
    },
    {
      q: "هل تقدّمون شهادات إتمام الدورات؟",
      a: "نعم. عند الإتمام تحصل على شهادة تثبت مهاراتك الجديدة، وهي إضافة مفيدة لسيرتك الذاتية أو ملفك المهني.",
    },
    {
      q: "كم تستغرق الدورات؟",
      a: "تختلف المدد حسب الموضوع. بعضها مكثّف وينتهي في أسابيع قليلة، وبعضها الآخر يمتد عدة أشهر. تفصّل صفحة كل دورة الوقت المطلوب.",
    },
    {
      q: "ماذا لو كانت لديّ أسئلة أثناء الدورة؟",
      a: "الدورات المباشرة تفاعلية، لذا اطرح أسئلتك في أي وقت. يتوفّر أيضًا دعم خارج الحصص من خلال منتدى المجتمع والجلسات الفردية.",
    },
  ],
};

export default ar;
